export default __webpack_public_path__ + "static/media/Urejevalnik_prepisov.3b71ab07.png";